export default class Boat {
    constructor(id, boat, amount_of_people) {
        this.id = id;
        this.boat = boat;
        this.amount_of_people = amount_of_people ?? 1;
    }
}